// Pure URL/attribute gate for sanitized message HTML (Finding-A residual G5).
//
// `prepare()` in HtmlBody.tsx strips `javascript:` URLs, but a `data:text/html`
// link survives that strip and — opened with
// `allow-popups-to-escape-sandbox` — escapes into an unsandboxed tab. This
// module holds the DOM-free predicate so the rule is unit-testable under
// `bun test` (no DOMParser in the bun runtime).
//
// URL schemes that must never survive in a navigation-capable attribute.
const UNSAFE_NAVIGATION_SCHEME = /^\s*(javascript|data|vbscript):/i;

// Attributes whose value navigates the frame or a new tab when activated.
// Media sources (img/video/audio src, poster) are deliberately excluded: the
// frame CSP allows `data:` images and media, and cid-resolved blob: URLs flow
// through src.
const NAVIGATION_ATTRIBUTES = new Set(["href", "xlink:href", "action", "formaction"]);

// True when an attribute must be removed from sanitized message HTML:
// inline event handlers, any `javascript:` URL, and `data:`/`vbscript:` URLs
// in navigation-capable attributes.
export function isUnsafeAttribute(name: string, value: string): boolean {
  if (/^on/i.test(name)) return true;
  if (/^\s*javascript:/i.test(value)) return true;
  return NAVIGATION_ATTRIBUTES.has(name.toLowerCase()) && UNSAFE_NAVIGATION_SCHEME.test(value);
}
